import { forwardRef } from 'react';
import DoubleIcon from '@assets/img/dice-game/2.svg?react';
import XIcon from '@assets/img/dice-game/x.svg?react';
import cn from 'classnames';

import { type DiceGameCardProps } from '@/common/types/dice-game';
import { Picture } from '@/components/ui/Picture/Picture';

import { ActiveBorder } from '../ActiveBorder/ActiveBorder';

import css from './styles.module.scss';

import blueBgPng from '/img/dice-game/blue-card-bg.png';
import blueBgWebp from '/img/dice-game/blue-card-bg.webp';

const DoubleBonusCard = forwardRef<HTMLDivElement, DiceGameCardProps>(
  ({ isActive, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(css.doubleBonusCard, props.className)}
      >
        <div className="absolute overflow-hidden rounded-xl top-0 left-0 w-full h-full">
          <Picture
            className="w-full h-full"
            img={blueBgPng}
            webp={blueBgWebp}
            alt="light"
          />
        </div>
        <XIcon className="relative z-[1] translate-x-[1px] translate-y-[3px] h-[15.92%] w-[15.92%]" />
        <DoubleIcon className="relative z-[1] h-[26.55%] w-[21.24%]" />
        {isActive && <ActiveBorder variant="blue" />}
      </div>
    );
  },
);

export { DoubleBonusCard };
